import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AfDetailModule, AfRowItemModule } from "@pattonair/auction-framework";
import { MfDialogModule } from "@pattonair/material-framework";
import { AucBidListComponent } from "./bid.list.component";

@NgModule({
  declarations: [
    AucBidListComponent,
  ],
  exports: [
    AucBidListComponent,
  ],
  imports: [
    BrowserModule,
    AfRowItemModule,
    AfDetailModule,
    MfDialogModule,
  ]
})
export class AucBidListModule { }